<div class="container">
  <div class="content">
    @if (action === Action.Edit || action === Action.New) {
      <div class="dialog-headline">
        @if (action === Action.Edit) {
          <h3>Edit file type</h3>
        }
        @if (action === Action.New) {
          <h3>Create new file type</h3>
        }
      </div>
      <div class="box">
        <div class="row">
          <coin-v2-text-input
            label="Name *"
            placeholder="Name"
            [matTooltip]="validateName() || 'Name of the file type'"
            [errorMessage]="validateName()"
            [(ngModel)]="item.displayedName"></coin-v2-text-input>
          <coin-v2-text-input
            label="Prefix *"
            placeholder="Prefix"
            [matTooltip]="
              validatePrefix() ||
              'Unique identifier for each file type (should be a short 2-4 digit sequence of letters - for internal use only)'
            "
            [errorMessage]="validatePrefix()"
            [disabled]="action === Action.Edit"
            [(ngModel)]="item.prefix"></coin-v2-text-input>
        </div>
        <div class="row">
          <coin-v2-text-input
            label="Identifier *"
            placeholder="Identifier"
            [matTooltip]="
              validateIdentifier() ||
              'Attribute (or coma-separated list of attributes) which uniquely identify each object'
            "
            [errorMessage]="validateIdentifier()"
            [disabled]="action === Action.Edit"
            [(ngModel)]="item.identifier"></coin-v2-text-input>
          <div>
            <coin-v2-checkbox
              matTooltip="Select Threshold"
              [ngModel]="thresholdCheckBoxState"
              (ngModelChange)="checkThresholdBox($event)"></coin-v2-checkbox>

            <coin-v2-text-input
              label="Threshold"
              placeholder="Threshold"
              [matTooltip]="
                validateThreshold() ||
                'Percentage of valid datasets which triggers an automatic import/reject (0 will automatically import any upload, disable for manual decision)'
              "
              [errorMessage]="validateThreshold()"
              [disabled]="disableThreshold"
              [(ngModel)]="temporaryThreshold"></coin-v2-text-input>
          </div>
        </div>
        <div class="row">
          <coin-dropdown
            label="File Format *"
            placeholder="Format"
            matTooltip="File format of the uploaded file"
            [items]="FORMAT"
            [disabled]="action === Action.Edit"
            [(ngModel)]="item.fileFormat"
            (selectionChange)="onFileFormatSelect($event)"></coin-dropdown>
          <coin-v2-text-input
            label="Delimiter"
            placeholder="Delimiter"
            [matTooltip]="validateDelimiter() || 'Character which separates the columns of the csv file'"
            [errorMessage]="validateDelimiter()"
            [disabled]="disableDelimiter || action === Action.Edit"
            [(ngModel)]="item.delimiter"></coin-v2-text-input>
        </div>
        <div class="row">
          <coin-v2-text-input
            label="Entity Wrapper"
            placeholder="Entity Wrapper"
            [matTooltip]="validateEntityWrapper() || 'Name of root level attribute which contains the list of objects'"
            [errorMessage]="validateEntityWrapper()"
            [disabled]="disableEntityWrapper"
            [(ngModel)]="item.entityWrapper"></coin-v2-text-input>
          <chip-input
            placeholder="new Address..."
            label="Email Addresses"
            matTooltip="multiple addresses possible - can be separated with Comma or Enter. Navigation with Arrows is possible"
            matTooltipPosition="below"
            [regExp]="emailRegex"
            [chips]="item.emailAddress"></chip-input>
        </div>
        <div class="row">
          <coin-v2-text-input
            label="Lambda Function ARN"
            placeholder="arn:aws:lambda:..."
            matTooltip="ARN of the Lambda function to trigger an automated import run"
            [(ngModel)]="item.lambdaFunctionArn"></coin-v2-text-input>
        </div>
        <div class="row">
          <coin-v2-text-input
            label="Retention Time"
            placeholder="Retention Time"
            [matTooltip]="
              validateRetention() ||
              'Amount of days which job data will be hold in S3 bucket. Does not affect data in the database (0 equals eternal retention)'
            "
            [errorMessage]="validateRetention()"
            [(ngModel)]="temporaryRetention"></coin-v2-text-input>
          <div style="margin-right: 80px">
            <coin-v2-checkbox
              matTooltip="Send Slack Notification"
              [ngModel]="slackNotificationCheckBoxState"
              (ngModelChange)="checkSlackNotificationBox($event)"></coin-v2-checkbox>
            Send Slack Notifications
          </div>
        </div>
        @if (action === Action.New) {
          <importer-export-attributes-form
            [entity]="item"
            [action]="action"
            (allValid)="validExportAttributes = $event"
            (allRequired)="requiredExportAttributes = $event"></importer-export-attributes-form>
        }
        @if (action === Action.New) {
          <div>
            <div class="schema-row">
              @if (schemaSourceFileName) {
                <coin-v2-text-input
                  label="Selected Schema Source File *"
                  style="margin-left: 20px"
                  [(ngModel)]="schemaSourceFileName"></coin-v2-text-input>
              }
              <ng-template #buttonsRightTemplate>
                <coin-v2-button
                  [type]="'primary'"
                  [icon]="'upload'"
                  [iconPos]="'right'"
                  [text]="schemaSourceFileName ? 'Change Schema Source File' : 'Select Schema Source File'"
                  [disabled]="uploading"
                  (click)="fileInput.click()"></coin-v2-button>
                <input
                  #fileInput
                  type="file"
                  style="display: none"
                  (change)="onFileSelected($event)" />
              </ng-template>
              <importer-button-footer
                style="margin: -1rem"
                [buttonsRightTemplate]="buttonsRightTemplate"></importer-button-footer>
            </div>
          </div>
        }
        <div class="buttons">
          <coin-v2-button
            [type]="'secondary'"
            [icon]="'close'"
            [iconPos]="'right'"
            [text]="'Cancel'"
            (click)="close()"></coin-v2-button>
          @if (action === Action.Edit) {
            <coin-v2-button
              [type]="'primary'"
              [icon]="'save'"
              [iconPos]="'right'"
              [text]="'Save'"
              [disabled]="uploading || !checkIfValid()"
              (click)="save()"></coin-v2-button>
          } @else {
            <coin-v2-button
              [type]="'primary'"
              [icon]="'create'"
              [iconPos]="'right'"
              [text]="'Create'"
              [disabled]="uploading || !checkIfValid()"
              (click)="create()"></coin-v2-button>
          }
        </div>
      </div>
      <mat-progress-bar
        [color]="progressBarColor"
        [mode]="progressMode"
        [value]="progressValue"></mat-progress-bar>
      <div class="info-footer">
        <p [class.error]="!validateRequired()">Fields marked with * are mandatory.</p>
      </div>
    }

    @if (action === Action.Delete) {
      <div class="dialog-headline">
        <h3>Delete file type</h3>
      </div>
      <div class="box">
        <div class="dialog-body">
          <p>Are you sure you want to delete this file type?</p>
        </div>
        <div class="buttons">
          <coin-v2-button
            [type]="'secondary'"
            [icon]="'close'"
            [iconPos]="'right'"
            [text]="'Cancel'"
            (click)="close()"></coin-v2-button>
          <coin-v2-button
            [type]="'primary'"
            [icon]="'delete'"
            [iconPos]="'right'"
            [text]="'Delete'"
            [disabled]="uploading"
            (click)="delete()"></coin-v2-button>
        </div>
      </div>
    }
  </div>
</div>
